import { Component, output } from '@angular/core';

import { GVCAmountInfo } from '../../../../config/appConstants';
import { DataGrid } from '../../../../model/common.model';
import { DepositInfo } from '../../../../model/depositInfo.model';
import { BehaviorDataService } from '../../../../service/behaviorData.service';
import { BonusService } from '../../../../service/bonus.service';
import { DepositService } from '../../../../service/deposit.service';
import { GtmService } from '../../../../service/gtm.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'gvc-amount-grid-buttons',
    templateUrl: 'amount-buttons.component.html',
    standalone: true,
})
export class GVCAmountGridButtonsComponent {
    depositInfo: DepositInfo;
    gridAmounts = GVCAmountInfo.gridAmounts;
    data = output<DataGrid>();

    constructor(
        private depositService: DepositService,
        private behaviorData: BehaviorDataService,
        private GTMService: GtmService,
        private bonusService: BonusService,
    ) {
        this.depositInfo = this.depositService.depositInfo;
    }

    fillAmount(event: any, value: any) {
        event.preventDefault();
        event.stopPropagation();
        document.getElementById('userAmount')?.focus();
        let nativeAmout = this.depositInfo?.amountInfo?.nativeAmountString || 0;

        nativeAmout = (parseFloat(nativeAmout) + parseFloat(value)).toFixed(2);
        const returnData = {
            nativeAmountString: nativeAmout,
            activeItem: value,
            amountGridIncrementalValue: 0,
            isGridSelected: true,
        };
        this.depositInfo.amountInfo.nativeAmountString = nativeAmout;
        this.data.emit(returnData);
        this.behaviorData.changeEnteredAmount(nativeAmout);
        this.bonusService.handleBonusAmount(this.depositInfo);
        this.GTMService.raiseOnChangeAmtGTMEvent('Deposit Amount - Select', 'PreSetAmountValues', nativeAmout);
    }
}
